module.exports = __webpack_public_path__ + "img/placeholder.0f58448f.png";